export default {
    data () {
        return {
            show: 1,
panel: [false, true, true]
      };
    }
};
